module.exports = __webpack_public_path__ + "img/jianshen.080409e5.png";